module.exports = __webpack_public_path__ + "img/birthday.e4235280.svg";